import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
ApexAxisChartSeries,
ApexChart,
ChartComponent,
ApexDataLabels,
ApexPlotOptions,
ApexResponsive,
ApexXAxis,
ApexYAxis,
ApexLegend,
ApexFill,
ApexTitleSubtitle,
ApexNonAxisChartSeries,
} from 'ng-apexcharts';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';


export type DonutChartOptions_ads = {
  series: any;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  plotOptions: any;
  colors: any;
  legend: any;
  xaxis: any;
  yaxis: any;
  fill: any;
  dataLabels: any;
  tooltip: any;
  stroke: any;
  states: any;
  title: any;
};

@Component({
  selector: 'app-ads-sidebar',
  templateUrl: './ads-sidebar.component.html',
  styleUrls: ['./ads-sidebar.component.css']
})
export class AdsSidebarComponent implements OnInit {
  @Input() isMemoryCardsAvailable:any;
  @Input() isFromHomeScreen:any = false;
  @Input() isInteracticeCardsAvailable:any;
  @Output() public exploreInteractiveActivities = new EventEmitter<any>();
  public donutchartOptions_ads: Partial<DonutChartOptions_ads>;

  pauseOnHover = false;
  pauseOnFocus = false;
  


  constructor(public selfLearnService:SelfLearnService, public router: Router) { }

  ngOnInit(): void {

    // donut chart
    this.donutchartOptions_ads = {
      series: [85],
      chart: {
        height: 120,
        width: '100%',
        type: 'radialBar',
        background: 'transparent',
        offsetX: 0,
        offsetY: 0,
      },
      plotOptions: {
        radialBar: {
          inverseOrder: false,
          startAngle: 0,
          endAngle: 360,
          offsetX: 0, // Move chart sides
          offsetY: 0, // Move chart top, bottom
          hollow: {
            margin: 0,
            size: '54%',
            background: '#E7E9FE',
            position: 'front'
          },
          track: {
            show: true,
            startAngle: undefined,
            endAngle: undefined,
            background: '#E7E9FE',
            strokeWidth: '100%',
            opacity: 1,
            margin: 5,
          },
          dataLabels: {
            show: true,
            name: {
              show: false,
              fontSize: '14px',
              fontFamily: undefined,
              fontWeight: 600,
              color: '#6073EE',
              offsetY: 20
            },
            value: {
              show: true,
              fontSize: '18px',
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 700,
              color: '#6073EE',
              offsetY: 7,
              formatter: function (val) {
                return val + '%';
              }
            }
          },
        },
      },
      labels: ["Total"],
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'horizontal',
          shadeIntensity: 0.5,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 0.5,
          opacityTo: 1,
          stops: [0, 100]
        },
        colors: ['#6073EE']
      },
      stroke: {
        lineCap: 'round'
      },
    };


  }
  navigateTomemorycards(){
    this.router.navigate([`selfLearn-V2/memory-card`]);
  }
  navigateToCardofTheDay(){
    this.router.navigate([`selfLearn-V2/card-of-the-day`]);
  }
  exloreInteractiveStories(){
    this.exploreInteractiveActivities.emit(1);
  }

}
